import { theme } from '@springcare/sh-component-library';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';

/**
 * Extend Verdant theme
 * @description: Just do this for non standard components, anything widely used should be added in the component library instead.
 * See all Chakra components on: https://v1.chakra-ui.com/docs/components/overview
 * More info about Verdant in: http://springcare.github.io/component-library
 */
const extendedTheme = extendTheme(theme.cgx, {
  colors: {
    pear: {
      100: '#e8f0b0',
    },
  },
  components: {
    Popover: {
      variants: {
        'full-width': {
          popper: {
            minWidth: '100% !important',
          },
        },
      },
    },
    Tabs: {
      defaultProps: {
        colorScheme: 'green',
      },
    },
    Spinner: {
      sizes: {
        '2xl': {
          height: '64px',
          width: '64px',
        },
        '3xl': {
          height: '80px',
          width: '80px',
        },
      },
    },
    Link: {
      baseStyle: {
        color: 'primary-base',
      },
      variants: {
        table: {
          fontSize: 'sm',
          textDecoration: 'none',
        },
        navigation: {
          _hover: {
            textDecoration: 'none',
          },
          textDecoration: 'none',
        },
      },
    },
  },
});

const ThemeProvider = ({ children }) => {
  return <ChakraProvider theme={extendedTheme}>{children}</ChakraProvider>;
};

export default ThemeProvider;
